export default __webpack_public_path__ + "static/media/adetolaolamide.4c8966cc.png";